import { render, staticRenderFns } from "./freezerMsgTotalStatistics.vue?vue&type=template&id=32f0ebd6&"
import script from "./freezerMsgTotalStatistics.vue?vue&type=script&lang=js&"
export * from "./freezerMsgTotalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./freezerMsgTotalStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports